import { AdTeamEditDrawer } from '@app/icare/routes/_app/adteam/-components/AdTeamEditDrawer'
import { t } from '@lingui/core/macro'
import { defineEntityConfig } from '@pkg/db/schema/EntityConfig'
import { FaPeopleGroup } from 'react-icons/fa6'
import { AdTeamSchema } from './schema/ADTeam'

export const ADTeamConfig = defineEntityConfig(() => ({
  schema: AdTeamSchema,

  label: t`AD-Team`,
  labelPlural: t`AD-Teams`,

  icon: FaPeopleGroup,

  route: {
    list: '/adteam',
    edit: '/adteam/$id',
  },

  drawer: { modal: AdTeamEditDrawer },

  relationSelectionColumns: [
    {
      title: t`Name`,
      key: 'name',
      render: (_, record) => record.name,
    },
  ],

  search: {
    sortableFields: ['name', 'createdAt'] as const,
    defaultSortBy: 'name',
    defaultSortOrder: 'asc',
  },

  format: {
    primary: val => val?.name,
  },
}))
